<template>
    <RouterView />
</template>

<script lang="js">
import { useAppStore, useUserStore } from '@stores';
import Navigation from '@components/navigation/Navigation.vue';
import Header from '@components/Header.vue';

export default {
    name: 'App',

    components: { Navigation },

    setup() {
        const appStore = useAppStore();
        const userStore = useUserStore();

        return { appStore, userStore };
    },

    mounted() {},
};
</script>

<style lang="scss" scoped>
@use '@scss/mixins.scss';

.layout {
    display: grid;
    grid-template-areas:
        'navigation header'
        'navigation main';
    grid-template-rows: auto 1fr;
    grid-template-columns: var(--main-navigation-width) 1fr;
    height: 100vh;

    main {
        grid-area: main;
        background: #fafafa;
        position: relative;

        .container {
            //padding: 30px;
        }

        .loadWrap {
            @include mixins.flex-column;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: calc(100% - var(--main-navigation-width));
            position: fixed;
            top: 0;
            left: var(--main-navigation-width);
        }
    }
}

.default {
    @include mixins.flex-column;
    height: 100vh;
}

/* Add your styles here if needed */
</style>
